export function calcPrix(tarifs,duree) {
    let prixArticle = 0;
    prixArticle += tarifs.demi * duree.demi;
    prixArticle += tarifs.jour * duree.jour;
    prixArticle += tarifs.semaine * duree.semaine;
    prixArticle += tarifs.deux_semaines * duree.bimensuel;
    prixArticle += tarifs.vingt_quatre * duree.vingtQuatre;
    return prixArticle;
}

export function calcPrixDegressif(tarifs,duree) {
    let prixArticle = 0;
    /* prixArticle += tarifs.demi * duree.demi;
    prixArticle += tarifs.jour * duree.jour;
    prixArticle += tarifs.semaine * duree.semaine;
    prixArticle += tarifs.deux_semaines * duree.bimensuel;
    prixArticle += tarifs.vingt_quatre * duree.vingtQuatre; */
    

   let taroJour=tarifs.jour ;
   let taroSemaine=tarifs.semaine;
   let tempJours=duree.jour;
   let tempSemaine=duree.semaine;
   let tempDemis = duree.demi;

   

    if (duree.semaine<1){ // si duree loc < 1 semaine
      
      if(((taroJour*tempJours)+(tarifs.demi*tempDemis))>taroSemaine) // si le forfait semaine est moins cher que le cumul des jours
      {
          
          tempSemaine=1;
          tempJours=0;
          tempDemis=0;
        }

    }

    else // duree loc > 1 semaine
    {
        
          tempDemis=0;
          taroJour = Math.round((tarifs.deux_semaines-tarifs.semaine) / 5);
          tempJours=tempJours>5?5:tempJours;

    }

    if(duree.bimensuel>=1)
    {
      tempDemis = 0 ;
      taroSemaine = tarifs.deux_semaines-tarifs.semaine;
      taroJour = Math.round(taroSemaine/5);
      tempJours=tempJours>5?5:tempJours;
    }
    
    
    let total=0;
    total+=tarifs.demi*tempDemis;
    total+=taroJour*tempJours;
    total+=tarifs.vingt_quatre*duree.vingtQuatre;
    total+=taroSemaine*tempSemaine;
    total+=tarifs.deux_semaines*duree.bimensuel;

    prixArticle = total;
    return prixArticle;

  }
